import 'jquery-modal';
import { closeSliderCart } from '../slider-cart';
import { initProductSwiperCarousel, destroyProductSwiperCarousel } from './products-carousel';
import { getSizedImageURL } from '../../core/images';

const openLookbookModal = (modal_type) => {
  $('html').addClass('modal--opened');

  closeSliderCart();
  $(modal_type).modal({
    fadeDuration: 250,
    fadeDelay: 0.80,
  });
};

// Extract the products from the images sections
const getProductsModal = (slide_i, block_id, retry = false) => {
  let product_handles = [];
  const $section_images = $(`[data-block-id="${block_id}"].gallery__row .gallery__image`);

  // Might happen if we try to load the next slide that doesn't exists
  if (!$($section_images[slide_i]).length) {
    return product_handles;
  }

  const $slide_products = $($section_images[slide_i]).find('.gallery__product');

  _.each($slide_products.find('a'), (product_link) => {
    if ($(product_link).data('product-handle').length) {
      product_handles.push($(product_link).data('product-handle'));
    }
  });

  // The following only works for 2 slides

  // Slide doesn't have products, use the previous ones
  if (!product_handles.length && slide_i > 0 && !retry) {
    product_handles = getProductsModal(slide_i - 1, block_id, true);
  }

  // Slide still doesn't have products, use the next ones
  if (!product_handles.length && !retry) {
    product_handles = getProductsModal(slide_i + 1, block_id, true);
  }

  // console.log('product_handles', product_handles);

  return product_handles;
};

const addLookbookCarousel = (block_id, selected_slide = 1) => {
  // Find the lookbook images
  const $section_images = $(`[data-block-id="${block_id}"].gallery__row .gallery__image img`);
  const img_srcs = [];
  let bkg_img = false;
  _.each($section_images, (section_image) => {
    let src = $(section_image).data('shopify-src');
    src = (typeof src === 'undefined' || src === null || !src.length) ? section_image.src : src;
    img_srcs.push(src);
  });

  // Images might be set as background images (three_items_v2 for instance)
  if (!$section_images.length) {
    _.each($(`[data-block-id="${block_id}"].gallery__row .gallery__image`), (section_image) => {
      img_srcs.push($(section_image).data('image'));
    });
    bkg_img = true;
  }

  // console.log('img_srcs', img_srcs);

  $('[data-gallery-products-modal-carousel-items]').empty().removeClass('swiper');

  let slider_needed = false;
  if (img_srcs.length > 1) {
    slider_needed = true;

    $('[data-gallery-products-modal-carousel-items]').addClass('swiper');
    $('[data-gallery-products-modal-carousel-items]').append(`<div class="swiper-wrapper"></div>`);
  }

  _.each(img_srcs, (img_src) => {
    let image_src = img_src;
    // let image_src = section_image.src;
    const image_w = 1800;

    if (bkg_img) {
      image_src = img_src;
    } else {
      /* eslint-disable */
      // Image loaded from Imgix
      if (image_src.indexOf('?') !== -1 && image_src.indexOf('imgix') !== -1) {
        image_src = `${image_src.split('?')[0]}?auto=format&w=${image_w}`;
      } else {
        image_src = getSizedImageURL(image_src, `${image_w}x`, true);
      }
      /* eslint-enable */
    }

    $(`[data-gallery-products-modal-carousel-items]${(slider_needed) ? ' .swiper-wrapper' : ''}`).append(`
      <div class="gallery-products-carousel__item${(slider_needed) ? ' swiper-slide' : ''}" data-gallery-products-carousel-item>
        <div class="gallery-products-carousel__image">
          <img src="${image_src}" title="Shoppable image" alt="Shoppable image" />
        </div>
      </div>
    `);
  });

  initProductSwiperCarousel('[data-gallery-products-modal-carousel-items]', selected_slide, block_id);

  // Add total items for css
  $('[data-gallery-products-modal-items]').attr('data-gallery-products-modal-items-total', $(`[data-block-id="${block_id}"]`).find('[data-products-carousel-json]').length);
};

const initProductsCarouselModal = () => {
  $(document).on('click', '[data-modal="#shoppable-modal"]', (e) => {
    const $item = $(e.currentTarget);
    openLookbookModal($item.data('modal'));
    const block_id = $item.closest('.gallery__row').data('block-id');
    const current_scrolltop = $(document).scrollTop();

    $($item.data('modal')).off($.modal.OPEN);
    $($item.data('modal')).on($.modal.OPEN, () => {
      $('[data-gallery-products-modal]').attr('data-block-id', block_id);
      addLookbookCarousel(block_id, $item.parent().data('gallery-item'));
    });

    $($item.data('modal')).off($.modal.CLOSE);
    $($item.data('modal')).on($.modal.CLOSE, () => {
      $('html').removeClass('modal--opened');
      destroyProductSwiperCarousel();
      $('[data-gallery-products-modal-carousel-items]').empty();
      $('[data-gallery-products-modal-items]').empty();
      $('[data-gallery-products-modal]').attr('data-block-id', '');
    });

    $($item.data('modal')).off($.modal.BEFORE_OPEN);
    $($item.data('modal')).on($.modal.BEFORE_OPEN, () => {
      $('html, body').scrollTop(current_scrolltop);
      $item.addClass('active');
    });

    $($item.data('modal')).off($.modal.AFTER_CLOSE);
    $($item.data('modal')).on($.modal.AFTER_CLOSE, () => {
      $('html, body').scrollTop(current_scrolltop);
      $item.removeClass('active');
    });
  });
};

// $(window).on('breakpointHasChanged', (e, current_breakpoint) => {
//   if ($('#shoppable-modal').is(':visible') && current_breakpoint === 'mobile') {
//     $('#shoppable-modal [rel="modal:close"]').trigger('click');
//   }
// });

export {
  initProductsCarouselModal,
  getProductsModal,
};
